export default "__VITE_ASSET___5CuFfeL__"